<template>
  
  <Header></Header>

  <div class="contaier" :class="{hideSidebar: isCollapse}">
    <Sidebar class="sidebar-container" :isCollapse="isCollapse">
      <div
        class="sidebar-togglebtn"
        :class="{collapse: isCollapse}"
        @click="toggleSideBar"
      ><el-icon><Back /></el-icon></div>
    </Sidebar>

    <div class="main-container" id="mainContainer">

      <Navbar v-if="!isIndex" :title="$route.meta.title" ref="nagivaion"></Navbar>

      <!-- 内容区 -->
      <AppMain></AppMain>
    </div>
  </div>
  
</template>

<script>
import { ref, watch } from "vue";
import Header from "./components/Header.vue";
import Sidebar from "./components/Sidebar/index.vue";
import Navbar from "./components/Navbar.vue";
import AppMain from "./components/AppMain.vue";
import { useRoute } from "vue-router";

export default {
  components: {
    Header,
    Navbar,
    Sidebar,
    AppMain,
  }, 
  setup() {
    const isIndex = ref(false);
    const isCollapse = ref(false);
    const route = useRoute();
    const currPath = route.path;
    if(currPath == '/' || currPath == ''){
      isIndex.value = true;
    }else {
      isIndex.value = false;
    }
    watch(() => route.path, (newVal) => {
      if(newVal == '/' || newVal == ''){
        isIndex.value = true;
      }else {
        isIndex.value = false;
      }
    });
    
    const toggleSideBar = ()=>{
      isCollapse.value = !isCollapse.value
    }
    return { isCollapse, toggleSideBar, isIndex };
  },

};
</script>

<style lang="less" scoped></style>
